<script>
import MetricItem from "@views/admin/treasury/trust-management/structured-lenders/MetricItem.vue";
import StructuredLenderItem from "@views/admin/treasury/trust-management/structured-lenders/StructuredLenderItem.vue";

export default {
  name: "StructuredLenders",
  components: {StructuredLenderItem, MetricItem},
  data: () => ({
    structuredLenders: []
  }),
  async mounted() {
    await this.fetchStructuredLenders()
  },
  methods: {
    async fetchStructuredLenders() {
      this.$vs.loading();

      const {data} = await axios.get("/api/backoffice/treasury/trust-management/structured-lender")
      this.structuredLenders = data;

      this.$vs.loading.close();
    },
  }
}
</script>

<template>
  <div class="container">
    <div
        class="text-center text-gray-500 mt-5"
        v-if="structuredLenders.length === 0"
    >
      <vx-card>
        No hay prestamistas registrados
      </vx-card>
    </div>

    <structured-lender-item
        v-else
        @onChanged="fetchStructuredLenders"
        :key="structuredLender.id"
        :structuredLender="structuredLender"
        v-for="structuredLender in structuredLenders" />

  </div>
</template>
